<script setup lang="ts">
import { usePathwayEventOverlay, usePathwayEvents } from '@/composables/game/pathway-events'

const { anyActivePathwayEvent, pathwayEvents } = usePathwayEvents()
const { showFirstPathway } = usePathwayEventOverlay()

</script>

<template>
  <span>Complete all 13 steps of
    <span
      :class="anyActivePathwayEvent ? 'text-green-primary' : 'pointer-events-none'"
      @click="showFirstPathway(pathwayEvents)"
    >Pathway Events</span> to unlock this achievement.
  </span>
</template>

<style scoped>

</style>